module.exports = __webpack_public_path__ + "static/img/00_mobile_internet.99125aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/moments/00_mobile_internet.png
// module id = tI6d
// module chunks = 1